import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import * as Yup from "yup";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { passwordUpdate } from "../../crud/auth.crud";

// console.log('Here')

function PasswordUpdate(props) {
  const { intl } = props;
  // const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  // console.log('Here2')
  const validationSchema = Yup.object().shape({
    profilePasswordConfirmation: Yup.string()
      .min(8, "Too Short")
      .oneOf([Yup.ref("profilePassword"), null], "Passwords must match"),
  });

  return (
    <>
      <div className="kt-login__head">
        {/* <span className='kt-login__signup-label'>
          Don't have an account yet?
        </span>
        &nbsp;&nbsp;
        <Link to='/auth/registration' className='kt-link kt-login__signup-link'>
          Sign Up!
        </Link> */}
      </div>

      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title" style={{ marginBottom: 0 }}>
            <h3>
              {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
              Your Password Needs to be Changed
            </h3>
            {/* <div className='login-message'>
              <p>Please enter your MFA Code  </p>
            </div> */}
          </div>

          <Formik
            initialValues={{
              profilePassword: "",
              profilePasswordConfirmation: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setStatus, setSubmitting }) => {
              // enableLoading();
              setTimeout(() => {
                const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
                passwordUpdate(values.profilePassword, values.profilePasswordConfirmation)
                  .then(({ data: { response } }) => {
                    // disableLoading();
                    // console.log(firstName);
                    props.passwordUpdate(response);
                  })
                  .catch((err) => {
                    // disableLoading();
                    setSubmitting(false);
                    if (err) {
                      if (err.response) {
                        if (err.response.data.message && err.response.data.message === "FailedPasswordUpdate") {
                          // console.log('Redirecting')
                          // console.log(props)
                          props.history.push("/auth/login");
                        }
                        if (err.response.data.message && err.response.data.message === "No Access") {
                          setStatus(
                            intl.formatMessage({
                              id: "AUTH.VALIDATION.FailedPasswordUpdate",
                            }),
                          );
                        }
                      }
                    }
                  });
              }, 1000);
            }}
          >
            {({ values, status, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
                {status ? (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">{status}</div>
                  </div>
                ) : (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">
                      <i className="far far-warning"></i> Confidential Information - Authorized access only.
                    </div>
                  </div>
                )}

                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>New Password</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="profilePassword"
                          value={values.profilePassword}
                          autoComplete="new-password"
                          onChange={handleChange}
                          isInvalid={touched.profilePassword && !!errors.profilePassword}
                          isValid={touched.profilePassword && !errors.profilePassword}
                        />
                        <InputGroup.Append onClick={() => setShowPassword(!showPassword)}>
                          <InputGroup.Text>
                            {showPassword ? (
                              <VisibilityOffIcon fontSize="small" style={{ marginLeft: -4 }} />
                            ) : (
                              <VisibilityIcon fontSize="small" style={{ marginLeft: -4 }} />
                            )}
                          </InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control.Feedback type="invalid">{errors.profilePassword}</Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Confirm Password</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="profilePasswordConfirmation"
                          value={values.profilePasswordConfirmation}
                          autoComplete="new-password"
                          onChange={handleChange}
                          isInvalid={touched.profilePasswordConfirmation && !!errors.profilePasswordConfirmation}
                          isValid={touched.profilePasswordConfirmation && !errors.profilePasswordConfirmation}
                        />
                        <InputGroup.Append onClick={() => setShowPassword(!showPassword)}>
                          <InputGroup.Text>
                            {showPassword ? (
                              <VisibilityOffIcon fontSize="small" style={{ marginLeft: -4 }} />
                            ) : (
                              <VisibilityIcon fontSize="small" style={{ marginLeft: -4 }} />
                            )}
                          </InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control.Feedback type="invalid">{errors.profilePasswordConfirmation}</Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="kt-login__actions">
                  <Button id="kt_login_signin_submit" type="submit" disabled={isSubmitting} variant="primary">
                    Update
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(PasswordUpdate));
